import {Component, OnInit} from '@angular/core';
import {UserService} from './user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public finished: boolean = false;
  public message: string = '';

  constructor(
    private _login: UserService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    let token: string = undefined;

    this._route.queryParams.subscribe((params) => (token = params['token']));

    if (token) {
      this.finished = true;

      this._login.login(token).subscribe(
        () => {
          if (this._login.isLoggedIn) {
            this._router.navigate(['./time-ticket']);
          } else {
            localStorage.clear();
            this.message =
              'El usuario no es válido.';
          }

          this.finished = false;
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.openSnackBar(error.error);
          } else {
            this.openSnackBar('Ocurrió un error inesperado');
          }

          this.finished = false;
        }
      );
    } else {
      localStorage.clear();
      this.message =
        "No haz iniciado sesión o tu sesión ha caducado. Por favor ingresa de nuevo por el Portal UDEM.";
    }
  }

  private openSnackBar(message: string) {
    this._snackBar.open(message, 'Ok', {
      duration: 8000,
    });
  }
}
